import { set } from 'lodash';
import { ROOT_PATH } from './get-value';
import { isDefined } from './is-defined';
export const setValue = (obj, path, value) => {
    if (path === ROOT_PATH) {
        if (isDefined(value)) {
            const rootObject = Object.keys(obj);
            const valueObject = Object.keys(value);
            rootObject.forEach((key) => {
                if (!valueObject.includes(key)) {
                    delete obj[key];
                }
            });
            Object.assign(obj, value);
        }
        else {
            Object.keys(obj).forEach((key) => delete obj[key]);
        }
        return;
    }
    set(obj, path, value);
};
//# sourceMappingURL=set-value.js.map